import React from 'react';
import '../styles/PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy for Lynx Private AI</h1>
      <p><strong>Effective Date: May 28, 2025</strong></p>

      <p>
        This Privacy Policy outlines the practices of Dubbah Inc. ("Dubbah," "we," "us," or "our")
        concerning information in relation to your use of the Lynx Private AI mobile application
        (the "Application" or "App"). Dubbah Inc. is committed to user privacy. The Application
        is engineered for complete privacy, leveraging an on-device Large Language Model (LLM)
        and does not transmit user data to our servers.
      </p>

      <h2>1. Scope of This Policy</h2>
      <p>
        This Policy applies to the Lynx Private AI Application. It is designed to be fully
        private. All data processing, including that performed by the LLM, occurs exclusively
        on the user's device.
      </p>

      <h2>2. Information Not Collected</h2>
      <p>
        Dubbah Inc. does not collect, process, store, or transmit any Personal Information (as defined
        by applicable privacy laws) or any other user-generated data from your device via the Application.
        The Application's design ensures that all user interactions and data remain localized.
        Specifically, we do not collect:
      </p>
      <ul>
        <li>
          <strong>Personal Identifiers:</strong> This includes, but is not limited to, names,
          email addresses, phone numbers, physical addresses, or precise geolocation data.
        </li>
        <li>
          <strong>Usage Data:</strong> We do not track your interactions within the Application,
          such as features utilized, content generated, or session durations. All such
          activity is confined to your device.
        </li>
        <li>
          <strong>Device or Network Information:</strong> We do not collect device-specific
          identifiers (e.g., UDID, IMEI), IP addresses, operating system details, or network
          information, beyond what is intrinsically necessary for the Apple App Store to
          distribute the Application and its updates.
        </li>
      </ul>

      <h2>3. On-Device Data Processing</h2>
      <p>
        The fundamental architecture of the Lynx Private AI Application ensures that all
        computational processes, including the operations of the integrated LLM, are performed
        locally on your iOS device. Any data inputted into the Application or generated by the
        Application as a result of your usage remains exclusively on your device and is not
        communicated to Dubbah Inc.'s servers or any third-party entities.
      </p>

      <h2>4. Network Communication</h2>
      <p>
        The Application's use of network resources is strictly limited to the following essential function:
      </p>
      <ul>
        <li>
          <strong>Model Downloads and Updates:</strong> The Application may periodically
          connect to designated servers to download or update the on-device LLM models.
          This communication is solely for the purpose of model retrieval and maintenance
          and does not involve the transmission of any personal data, usage metrics, or
          other user-specific information.
        </li>
      </ul>

      <h2>5. Absence of Tracking and Analytics</h2>
      <p>
        The Lynx Private AI Application does not incorporate any first-party or third-party
        tracking mechanisms, analytics software, advertising SDKs, or similar technologies
        that would facilitate the collection or transmission of user data.
      </p>

      <h2>6. Data Security</h2>
      <p>
        Given that all user data and processing activities are confined to the user's device,
        the security of such data is primarily governed by the security measures and protocols
        inherent in the iOS operating system and the user's own device security practices.
        Dubbah Inc. does not have access to, nor control over, data stored on your device.
      </p>

      <h2>7. Age Restriction and Children's Privacy</h2>
      <p>
        The Lynx Private AI Application is intended for users who are at least 17 years of age.
        Dubbah Inc. does not knowingly collect any personal information from any user.
        If you are under the age of 17, you are not permitted to use this Application.
        As we do not collect personal information, we inherently do not collect such
        information from individuals under this age threshold.
      </p>

      <h2>8. Amendments to This Privacy Policy</h2>
      <p>
        Dubbah Inc. reserves the right to modify this Privacy Policy at any time. Should
        material changes be made, we will provide notice by updating the "Effective Date"
        at the top of this Policy and posting the revised Policy within the Application or
        on our website. Your continued use of the Application after such modifications
        will constitute your acknowledgment of the modified Policy. We encourage users to
        periodically review this Privacy Policy.
      </p>

      <h2>9. Inquiries</h2>
      <p>
        Should you have any questions or require clarification regarding this Privacy Policy
        or our privacy practices, please contact Dubbah Inc. at: coleman@dubbah.co.
      </p>

      <hr />
      <p>
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;